import { makeStyles, tokens } from '@fluentui/react-components';

export const useToolbarStyles = makeStyles({
  toolbar: {
    backgroundColor: tokens.colorBrandBackground,
    justifyContent: 'space-between',
  },
  toolbarButton: {
    fontWeight: 400,
    marginTop: '8px',
    marginBottom: '8px',
  },
});
